import React from 'react';
import PropTypes from 'prop-types';

const Radio = ({ options, id, value, onChange, withOutline, vertical }) => {

  return (
    <div className={`radio ${vertical ? 'vertical' : ''}`}>
      {options && options.map(({ id: optionId, name, value: optionValue, disabled }) => {
        const checked = value === optionValue;
        return (
          <div
            className={`${vertical ? '' : 'radioItem'} ${withOutline ? 'withOutline' : ''} ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
            key={optionId}
          >
            <input
              type="radio"
              name={`radio-${id}`}
              className="radio-input"
              id={`radio-${id}-${optionId}`}
              checked={checked}
              onChange={() => onChange(optionValue)}
              disabled={disabled}
            />
            <label htmlFor={`radio-${id}-${optionId}`}>{name}</label>
          </div>
        );
      })}
    </div>
  );
};

Radio.propTypes = {
  options: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  withOutline: PropTypes.bool,
  vertical: PropTypes.bool,
};

export default Radio;
